import Phaser from 'phaser';
import type { Direction } from '../types';

export class ConnectVan extends Phaser.GameObjects.Container {
  private readonly glow: Phaser.GameObjects.Arc;
  private readonly signal: Phaser.GameObjects.Arc;
  private readonly shield: Phaser.GameObjects.Arc;
  private readonly speedLines: Phaser.GameObjects.Graphics;

  constructor(scene: Phaser.Scene, x: number, y: number, reducedMotion: boolean) {
    super(scene, x, y);
    scene.add.existing(this);
    this.setDepth(35);
    this.glow = scene.add.circle(0, 4, 38, 0x168cff, 0.18);
    this.speedLines = scene.add.graphics();
    this.speedLines.lineStyle(4, 0xff6b2a, 0.9).lineBetween(-42, -8, -28, -8).lineBetween(-48, 4, -28, 4).lineBetween(-41, 16, -27, 16);
    const body = scene.add.graphics();
    body.fillStyle(0xffffff, 1).fillRoundedRect(-29, -18, 56, 36, 9);
    body.fillStyle(0xff5a2a, 1).fillRoundedRect(-29, 5, 56, 13, 5);
    body.fillStyle(0x06152f, 1).fillRoundedRect(-12, -13, 30, 15, 4);
    body.fillStyle(0x168cff, 1).fillRect(-26, -10, 10, 15);
    body.fillStyle(0x020916, 1).fillCircle(-16, 19, 7).fillCircle(17, 19, 7);
    body.fillStyle(0x1ed8ff, 1).fillCircle(-16, 19, 3).fillCircle(17, 19, 3);
    body.fillStyle(0xffd15c, 1).fillRect(23, -3, 6, 8);
    const mark = scene.add.text(-2, 10, 'TC-360', { fontFamily: 'Arial Black, Arial', fontSize: '8px', color: '#ffffff' }).setOrigin(0.5);
    this.signal = scene.add.circle(-8, -26, 4, 0x1ed8ff, 1).setStrokeStyle(3, 0x1ed8ff, 0.8);
    const antenna = scene.add.rectangle(-8, -21, 3, 8, 0xffffff, 1);
    this.shield = scene.add.circle(0, 2, 39, 0xff8a34, 0.08).setStrokeStyle(4, 0xffb37a, 1).setVisible(false);
    this.add([this.glow, this.speedLines, body, mark, antenna, this.signal, this.shield]);
    if (!reducedMotion) {
      scene.tweens.add({ targets: this.glow, scale: 1.25, alpha: 0.03, duration: 650, yoyo: true, repeat: -1 });
      scene.tweens.add({ targets: this.signal, scale: 2.4, alpha: 0.08, duration: 760, repeat: -1 });
    }
  }

  face(direction: Direction): void {
    if (direction === 'left') this.setScale(-Math.abs(this.scaleX), Math.abs(this.scaleY));
    if (direction === 'right') this.setScale(Math.abs(this.scaleX), Math.abs(this.scaleY));
  }

  reactCollect(): void { this.scene.tweens.add({ targets: this, scaleY: 1.18, duration: 70, yoyo: true }); }
  reactHit(): void { this.scene.tweens.add({ targets: this, alpha: 0.25, duration: 80, yoyo: true, repeat: 4 }); }
  celebrate(): void { this.scene.tweens.add({ targets: this, y: this.y - 18, angle: 5, duration: 170, yoyo: true, repeat: 2 }); }
  connectionLost(): void { this.reactHit(); }
  setProtected(active: boolean): void { this.shield.setVisible(active); }
  setBoosted(active: boolean): void { this.speedLines.setAlpha(active ? 1 : 0.5).setScale(active ? 1.35 : 1); }
  setCommunityBoost(active: boolean): void { this.signal.setFillStyle(active ? 0xffd15c : 0x1ed8ff, 1); }
}
